import { z } from "zod";
import { SimProfileSchema } from "./scenarios.js";

// ── Perfil de simulação POR PAR (máquina×produto) ─────────────────────────────
// Reusa os campos reais do SimProfileSchema (feedRateUnH deriva o ciclo; ciclo NÃO é campo).
// NÃO traz provenance/sampleCount/provenanceByParam: aqueles descrevem a derivação por máquina;
// aqui é override AUTORADO por par. Extensível de propósito (Fase 3 adiciona setupMinutes —
// pesquisa de contrato): `.strict()` só na borda de entrada; leitura/armazenamento tolerante.
export const PairSimProfileSchema = SimProfileSchema.pick({
  feedRateUnH: true,
  mtbfMin: true,
  mttrMin: true,
  qualityTargetPct: true,
}).extend({
  // Custo de PREPARAR esta máquina para ESTE produto (troca/setup). Campo
  // PRÓPRIO do par: não existe em SimProfileSchema porque perfis por máquina/cenário não têm
  // troca. Não entra em applyPairProfile (não é taxa contínua) — viaja em paralelo até o motor,
  // que o cobra na troca de produto. Ausente ⇒ 0. Autorado-apenas nesta fase.
  setupMinutes: z.number().min(0).max(1440).optional(),
});
export type PairSimProfile = z.infer<typeof PairSimProfileSchema>;

export const CompatibilityEntrySchema = z.object({
  machineId: z.string().uuid(),
  productId: z.string().uuid(),
  enabled: z.boolean().default(true),
  // Substitui o campo morto `exceptions`. Ausente/null ⇒ par sem perfil (comportamento
  // antigo: compatível + parâmetros por-máquina). Perfil parcial é válido (cada campo opcional).
  simProfile: PairSimProfileSchema.nullable().optional(),
});
export type CompatibilityEntry = z.infer<typeof CompatibilityEntrySchema>;

export const UpsertCompatibilityRequestSchema = z.object({
  entries: z.array(CompatibilityEntrySchema).min(1).max(500),
});
export type UpsertCompatibilityRequest = z.infer<typeof UpsertCompatibilityRequestSchema>;

// ── Preview de viabilidade produto×linha (gate ao vivo) ───────────────────────
// Antecipa, de forma síncrona, a checagem que o motor faz em runtime
// (apps/simulation/src/feasibility.py): linha viável se ≥1 máquina ativa
// (não-STOPPED, não-HUMAN) é compatível com o produto. Default true sem matriz.
export const FeasibilityQuerySchema = z.object({
  productId: z.string().uuid(),
});
export type FeasibilityQuery = z.infer<typeof FeasibilityQuerySchema>;

export const FeasibilityResponseSchema = z.object({
  feasible: z.boolean(),
  reason: z.string().nullable(),
  productId: z.string().uuid(),
  lineId: z.string().uuid(),
});
export type FeasibilityResponse = z.infer<typeof FeasibilityResponseSchema>;

export const FeasibilityEnvelopeSchema = z.object({
  data: FeasibilityResponseSchema,
  error: z.null(),
});
